import { DeviceModelPortSpecificationWithStatusOutput } from './device-model-port-specification-with-status-output.model';


export class DeviceModelPortSpecificationSelectByIdOutput implements IDeviceModelPortSpecificationSelectByIdOutput {
    status!: number;
    message!: string;
    data!: DeviceModelPortSpecificationWithStatusOutput;

    constructor(data?: IDeviceModelPortSpecificationSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? DeviceModelPortSpecificationWithStatusOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceModelPortSpecificationSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelPortSpecificationSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDeviceModelPortSpecificationSelectByIdOutput {
    status: number;
    message: string;
    data: DeviceModelPortSpecificationWithStatusOutput;
}

